import App from 'app/App';
import ReactDOM from 'react-dom/client';

// -----------------------------
// React Root 생성 및 렌더링
// -----------------------------
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);
root.render(<App />);

// -----------------------------
// ag-grid 라이센스 관련 콘솔 오류 무시
// -----------------------------
const originalConsoleError = console.error;

console.error = (...args: any[]) => {
  if (
    args[0] &&
    typeof args[0] === 'string' &&
    (args[0].includes('Grid Enterprise License') ||
      args[0].includes('Invalid License Key') ||
      args[0].includes('Your license key is not valid') ||
      args[0] ===
        '****************************************************************************************************************************')
  ) {
    return;
  }

  originalConsoleError(...args);
};
